<div fxLayout="column" fxLayoutAlign="center center">
  <div class="faq">
    <h1>FAQ</h1>
    <p><strong>Overview:</strong> The Discipleship Path [DP] is simply a general guide to give direction to your
      spiritual walk with God. While
      this 'walk' is emphasized throughout God's word, it can be expressed in two verses</p>
    <ol>
      <li>The command to have a personal walk with God [Mark 12:30]</li>
      <li>The walk can be defined in 3 general segments [1 John 2:14] [note the 4th segment is one who has not trusted
        in
        Christ.]</li>
    </ol>
  </div>
  <hr class="divider" />
  <div class="question">
    <h2>Can I have a personal relationship with God? Does he want one?</h2>
    <p>The God who created us, knows everything about you. He knows what you want before you ask. More important than
      wants, he knows your needs. Just as we build relationship with a best friend or spouse. Our walk with God has the
      same; progression. You need to spend time getting to Know him, which leads to Love him, which then leads to Trust
      him, and finally Obey him.</p>
  </div>
  <div class="question">
    <h2>What is a Discipleship Path, why are there 4 steps or groupings?</h2>
    <p>
      1 John 4: 4-6 alludes to 3 groups 1) infants, those who are on milk 2) young, those who are growing stronger and
      3)
      adults, those who are maturing in their faith. The 4th group is a natural group, those who have not accepted
      Christ.
    </p>
  </div>
  <div class="question">
    <h2>Ok, I get it, but what should I focus on to improve my walk?</h2>
    <p>Christ spoke much about these things. He identified what we call 5 major “Pillars” for you spiritual movement:
      Prayer, Bible, Serving, Giving, and Inviting.</p>
  </div>
  <div class="question">
    <h2>How long will this DP take?</h2>
    <p>Probably eternity. No kidding The Bible states that we will spend eternity knowing more about this infinite God
      we
      serve. Jesus said we should start to know him on this side of eternity.</p>
  </div>
  <div class="question">
    <h2>Why not wait until I get to heaven to grow closer to God? Or What does a Discipleship Path have to do with me?
    </h2>
    <p>The closer we get to God here on earth will glorify God? How we treat others, how we respond in trials, how we
      serve and give, all these aspects, and more, are relevant to the degree we are close to God.</p>
  </div>
  <div class="question">
    <h2>I think I am in the Exploring Christ have never accepted Christ as my Lord and Savior. What should I do?</h2>
    <p>The sinner's prayer is a prayer a person prays to God when they understand that they are a sinner and in need of
      a
      Savior. Saying a sinner's prayer will not accomplish anything on its own. A true sinner's prayer only represents
      what a
      person knows, understands, and believes about their sinfulness and need for salvation.</p>
  </div>
  <div class="question">
    <h2>How fast should I be moving along my Discipleship Path?</h2>
    <p>There is no right or wrong spiritual walk. Everyone's walk is different. However, you should always be moving and
      growing. The primary goal is to have movement out of “Exploring Christ” as soon as possible.</p>
  </div>
  <div class="question">
    <h2>So where do I start? What steps do I take?</h2>
    <p>Start with the DP Self-Assessment. Review the DP next step guides. It is that simple, but few take the journey.
      Pray
      for God's guidance...he loves those who seek him [Prov 8:17]</p>
  </div>
  <div class="question">
    <h2>I think I got this right?</h2>
    <p>Realize there is a path. Start moving on that path.</p>
  </div>
</div>